import { render, staticRenderFns } from "./ProfileSuspended.vue?vue&type=template&id=60d84b2e&scoped=true"
import script from "./ProfileSuspended.vue?vue&type=script&lang=js"
export * from "./ProfileSuspended.vue?vue&type=script&lang=js"
import style0 from "./ProfileSuspended.vue?vue&type=style&index=0&id=60d84b2e&prod&lang=css"
import style1 from "./ProfileSuspended.vue?vue&type=style&index=1&id=60d84b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d84b2e",
  null
  
)

export default component.exports